import React from "react";
import Loader1 from "../../../assets/img/loader1.jpg";
import Loader2 from "../../../assets/img/loader2.jpg";
import Loader3 from "../../../assets/img/loader3.jpg";
import Loader4 from "../../../assets/img/loader4.jpg";
import Loader5 from "../../../assets/img/loader5.jpg";
import "./Loader.scss";

interface LoaderProps {
  text?: string;
  delay?: number;
}

function Loader(props: LoaderProps) {
  const { text } = props;
  return (
    <div className="Loader" data-testid="loader">
      <div className="Loader__cards">
        <div className="Loader__cardWrapper">
          <img
            src={Loader1}
            className="Loader__card Loader__card--first"
            role="presentation"
          />
        </div>
        <div className="Loader__cardWrapper">
          <img
            src={Loader2}
            className="Loader__card Loader__card--second"
            role="presentation"
          />
        </div>
        <div className="Loader__cardWrapper">
          <img
            src={Loader3}
            className="Loader__card Loader__card--third"
            role="presentation"
          />
        </div>
        <div className="Loader__cardWrapper">
          <img
            src={Loader4}
            className="Loader__card Loader__card--fourth"
            role="presentation"
          />
        </div>
        <div className="Loader__cardWrapper">
          <img
            src={Loader5}
            className="Loader__card Loader__card--fifth"
            role="presentation"
          />
        </div>
      </div>
      <p className="Loader__text">
        {text && text.length > 0 ? text : "Loading... Please wait"}
      </p>
    </div>
  );
}

export default Loader;
